import { render, staticRenderFns } from "./PricesHome.vue?vue&type=template&id=7ea0cb42&"
import script from "./PricesHome.vue?vue&type=script&lang=js&"
export * from "./PricesHome.vue?vue&type=script&lang=js&"
import style0 from "./PricesHome.vue?vue&type=style&index=0&id=7ea0cb42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports